<script>
  import Breadcrumbs from "@/core/components/Breadcrumbs"
  import Icon from "@/core/components/Icon"
  // import Select from "@/core/components/Select";
  import TicketsList from "@/domains/support/partials/TicketsList"
  import DropdownSelect from "../../../core/components/DropdownSelect.vue"

  export default {
    components: {
      Breadcrumbs,
      Icon,
      // Select,
      DropdownSelect,
      TicketsList,
    },
    data: () => {
      return {
        title: "Chamados",
        crumbs: [
          { name: "Início", path: "index" },
          { name: "Suporte", path: "support.index" },
          { name: "Chamados", path: "support.ticket" },
        ],
        search: "",
        closed: 0,
      }
    },
    mounted() {
      document.title = this.title + " - " + process.env.VUE_APP_TITLE
    },
  }
</script>

<template>
  <div class="w-full bg-gray-light">
    <div class="px-2 my-4 sm:px-6">
      <Breadcrumbs class="mb-6" :crumbs="crumbs"/>
      <div class="grid grid-cols-1 sm:grid-cols-2">
        <div class="w-full lg:w-auto lg:mb-0">
          <router-link
            tag="button"
            class="px-2 py-2 mb-2 form-new-green sm:py-1"
            :to="{ name: 'ticket.create' }"
          >
            <div class="flex items-center justify-center">
              <Icon icon="plus" class="h-4 mr-1 fill-current"/>
              Novo chamado
            </div>
          </router-link>
        </div>
        <div
          class="flex flex-col justify-end flex-grow text-xs sm:flex-row sm:flex-wrap"
        >
          <div class="w-full sm:w-60 md:w-64 mb-3 sm:mb-1">
            <DropdownSelect
              class="z-10 w-full"
              :options="[
                                { value: '0', label: 'Abertos' },
                                { value: '1', label: 'Resolvidos' }
                            ]"
              :selected="closed"
              @update:selected="closed = $event"
            />
          </div>
          <form
            @submit.prevent="$refs.table.getTickets"
            class="flex w-full mb-2 sm:w-auto md:mb-1 sm:mx-1"
          >
            <div class="relative inline-block w-full">
              <button
                type="submit"
                class="absolute right-0 flex items-center hidden p-2 border-b rounded-r-sm md:block border-green-light bg-green-background active:bg-image-none active:bg-green-darkest"
              >
                <Icon icon="search" class="h-4 text-white fill-current"/>
              </button>
              <input v-model="search" class="pl-4 filter-search" type="text">
            </div>
            <button
              class="flex items-center justify-center w-32 ml-1 md:hidden form-submit"
              type="submit"
            >
              Pesquisar
            </button>
          </form>
        </div>
      </div>
      <div>
        <TicketsList ref="table" :closed="closed" :search="search"/>
      </div>
    </div>
  </div>
</template>
